import React, { useEffect, useState, useCallback, useContext } from "react";
import "./PagingTable.scss";
import {
    Table,
    NavDropdown
} from "react-bootstrap";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { IntlProvider } from "react-intl";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
    ArrowCounterclockwise,
    ArrowDown,
    ArrowUp,
    CardHeading,
    CardList,
    Check,
    List
} from "react-bootstrap-icons";
import ReactTooltip from "react-tooltip";
import VisibilitySensor from "react-visibility-sensor";
import {
    Menu,
    useContextMenu,
    animation
  } from "react-contexify";
import { AppReducer, APP_ACTIONS } from "../state/AppReducer";
import { AppContext } from "../state/AppContext";
import { IconButton, Divider, Button } from "@material-ui/core";
import AppState from "../state/AppState";
import SessionCell from "../sessions/SessionCell";
import SessionHeader from "../sessions/SessionHeader";
import getSessionColumns from "../sessions/SessionColumns";
import SessionCard from "../sessions/SessionCard";
import MenuOpen from "@material-ui/icons/MenuOpen";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { Cached, ViewHeadline, ViewStream, ViewComfy } from "@material-ui/icons";
  

const BATCH_SIZE = 100;

function PagingTable({ match, history, state, dispatchState, rendererName, reducerActions, toolbar, contextMenuItems }) {

    const { appState, dispatchAppState } = useContext(AppContext);

    const [columns, setColumns] = useState([]);
    const [nbColumns, setNbColumns] = useState(1);
    const [batch, setBatch] = useState(0);
    const [lastNodeId, setLastNodeId] = useState({});

    const { t } = useTranslation();

    let _view = localStorage.getItem(rendererName + "-" + match.params.sessionType + "-view");
    if (_view === "" || _view === "null") {
        _view = "LIST";
    }
    localStorage.setItem(rendererName + "-" + match.params.sessionType + "-view", _view);
    const [view, setView] = useState(_view);
    const switchView = (_view) => {
        localStorage.setItem(rendererName+ "-" + match.params.sessionType + "-view", _view);
        setView(_view);
    };

    const getSortUrl = (params) => {
        let url = "/app/content/" +
        params.money +
        "/" +
        params.sessionType +
        "/" +
        params.hero +
        "/" +
        rendererName +
        "/" +
        params.nodeId +
        "/" +
        params.sort +
        "/" +
        params.dir;
        return url;
      };
    
    const sortColumn = (column, keep = false, evt = null) => {
        //console.log("sorting column", column.name);
        if (evt !== null) {
            evt.stopPropagation();
        }
        let params = {};
        Object.assign(params, match.params);
        console.log("params", params);
        let dir = match.params.dir;
        if (!keep) {
            if (dir === "asc") {
                dir = "desc";
            } else {
                dir = "asc";
            }
        }
        params.sort = column.name;
        params.dir = dir;
        history.push(getSortUrl(params));
    };

    const toggleDir = (evt) => {
        evt.stopPropagation();
        let dir = match.params.dir;
        if (dir === "asc") {
            dir = "desc";
        } else {
            dir = "asc";
        }

        let params = {};
        Object.assign(params, match.params);
        params.dir = dir;
        //console.log("params", params);
        history.push(getSortUrl(params));
    };

    const toggleRowCheck = (row) => {
        dispatchState({
            type: reducerActions.ROWS_SELECTION,
            payload: {
                ids: [row.id],
                checked: !row.checked
            }
        });
    };

    const toggleRowsCheck = () => {
        let _allChecked = true;
        let ids = [];
        state.data.forEach((row) => {
            if (!row.checked) {
                _allChecked = false;
            }
            ids.push(row.id);
        });
        dispatchState({
            type: reducerActions.ROWS_SELECTION,
            payload: {
                ids: ids,
                checked: !_allChecked
            }
        });
    };

    const loadData = useCallback((_batch) => {

        dispatchState({
            type: reducerActions.LOAD,
            params : match.params,
            batch : _batch,
            callback : (data)=>{
              if (_batch === 0) {
                dispatchState({
                    type: reducerActions.DATA_UPDATED,
                    payload: data
                });
              } else {
                dispatchState({
                    type: reducerActions.DATA_ADDED,
                    payload: data
                });
              }
              setBatch(_batch + 1);
              let _columns = getSessionColumns(match.params.sessionType, view==="COMPACT");
              //COLUMNS
              setColumns(c=>_columns);
              let _nbColumns = 1;
              _columns.forEach(column=>{
                  if(column.visible &&
                      (view !== "COMPACT" || !column.hideWhenCompacted)){
                          _nbColumns++;
                      }
              });
              setNbColumns(n=>_nbColumns);
            }
        });
    }, [dispatchState, match.params, reducerActions, view]);

    const { show } = useContextMenu({
        id: "context-menu"
    });

    const handleContextMenu  = (event) => {
        //CONTEXT MENUITEMS
        if(state.selectedRows.length>0){
            show(event);
        }
    };

    const openRow =(row)=>{
        dispatchState({
            type: reducerActions.OPEN_ROW,
            sessionId: row.id,
            heroId : match.params.hero
        });
    }

    const showNavigation= ()=>{
        dispatchAppState({
          type: APP_ACTIONS.NAVIGATION_TOGGLE,
          show: true
        });
      }
    
    useEffect(() => {
        console.log("pagingtable effect", state);
        //let now = new Date();
        //console.log("view in " + (new Date() - now));
        if(lastNodeId.nodeId!==match.params.nodeId || lastNodeId.sort!==match.params.sort || lastNodeId.dir!==match.params.dir){
            console.log(lastNodeId, match.params);
            setLastNodeId(match.params);
            loadData(0);
        }
        //console.log("inited in " + (new Date() - now));
        //console.log("match", match);
        return () => {
            console.log("pagingtable effect done");
        };
    }, [match.params, state, loadData, lastNodeId]);
    return (
        <div className={"paging-table table-" + rendererName+ " view-" + view} onContextMenu={handleContextMenu}>
            <Menu
                id="context-menu"
                animation={animation.flip}
            >
                {contextMenuItems}
            </Menu>
            <ReactTooltip />
            <div className="paging-table-container">
                <div className="toolbar">
                <IconButton
                    className="xeester-navigationbar-toggle"
                    color="inherit"
                    aria-label="Open navigation bar"
                    edge="start"
                    onClick={showNavigation}
                >
                <MenuOpen />
                </IconButton>
                <Divider orientation="vertical" flexItem />
                {toolbar}
                <Divider orientation="vertical" flexItem />
                <IconButton onClick={() => { loadData(0); }} className="reload"><Cached></Cached></IconButton>
                <Divider orientation="vertical" flexItem />
                <div className="total">{state.total} {t("app."+rendererName+".total."+(state.total>1?"plural":"singular"))}</div>
                    <NavDropdown
                        title={t(
                            "app." +
                            rendererName+
                            ".columns." +
                            match.params.sort +
                            ".title"
                        )}
                        className="list-sort-dropdown"
                    >
                        <PerfectScrollbar>
                            {columns.map((column) => (
                                <NavDropdown.Item onClick={() => sortColumn(column, true)}>
                                    {t(
                                        "app." +
                                        rendererName+
                                        ".columns." +
                                        column.name +
                                        ".title"
                                    )}
                                </NavDropdown.Item>
                            ))}
                        </PerfectScrollbar>
                    </NavDropdown>
                    <Button onClick={toggleDir}>
                        {match.params.dir === "asc" ? (
                            <ArrowUp></ArrowUp>
                        ) : (
                            <ArrowDown></ArrowDown>
                        )}
                    </Button>
                    <ToggleButtonGroup
                        id="view_switcher"
                        value={view}
                        type="checkbox"
                        aria-label="View"
                    >
                        <ToggleButton
                            value={"LIST"}
                            variant="secondary"
                            onClick={() => switchView("LIST")}
                        >
                            <ViewHeadline></ViewHeadline>
                        </ToggleButton>
                        <ToggleButton
                            value={"COMPACT"}
                            variant="secondary"
                            onClick={() => switchView("COMPACT")}
                        >
                            <ViewStream></ViewStream>
                        </ToggleButton>
                        <ToggleButton
                            value={"CARDS"}
                            variant="secondary"
                            onClick={() => switchView("CARDS")}
                        >
                            <ViewComfy></ViewComfy>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <PerfectScrollbar>
                    <IntlProvider locale={i18n.language} defaultLocale="en">
                        {view !== "CARDS" ? (
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th className="select-th">
                                            <div
                                                className="select-checkbox"
                                                onClick={() => toggleRowsCheck()}
                                            >{state.allChecked === 2 ? <Check size="16"></Check> : state.allChecked === 1 ? "-" : ""}
                                            </div>                                    
                                        </th>
                                        {columns.map((column) =>
                                            column.visible &&
                                                (view !== "COMPACT" || !column.hideWhenCompacted) ? (
                                                <th
                                                    style={{
                                                        width: column.width + "px"
                                                    }}
                                                    data-tip={t(
                                                        "app." +
                                                        rendererName+
                                                        ".columns." +
                                                        column.name +
                                                        ".name"
                                                    )}
                                                    className={"column-" + column.name}
                                                    onClick={() =>
                                                        sortColumn(
                                                            column,
                                                            column.name !== match.params.sort
                                                        )
                                                    }
                                                >
                                                    <div
                                                    >
                                                        <SessionHeader column={column}></SessionHeader>
                                                        {column.sortable && column.name === match.params.sort ? (
                                                            match.params.dir === "asc" ? (
                                                                <ArrowUp
                                                                    size="16"
                                                                    onClick={(evt) =>
                                                                        sortColumn(column, false)
                                                                    }
                                                                ></ArrowUp>
                                                            ) : (
                                                                <ArrowDown
                                                                    size="16"
                                                                    onClick={(evt) =>
                                                                        sortColumn(column, false)
                                                                    }
                                                                ></ArrowDown>
                                                            )
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                </th>
                                            ) : (
                                                <></>
                                            )
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.data.map((row, index) =>
                                        <tr
                                            key={index}
                                            className={row.checked ? "checked" : ""}
                                            onDoubleClick={() => openRow(row)}
                                        >
                                            <td className="select-td">
                                                <div
                                                    className="select-checkbox"
                                                    onClick={() => toggleRowCheck(row)}
                                                >{row.checked ? <Check size="16"></Check> : ""}</div>
                                            </td>
                                            {columns.map((column) =>
                                                column.visible &&
                                                    (view !== "COMPACT" ||
                                                        !column.hideWhenCompacted) ? (
                                                    <td style={{ textAlign: column.align }} className={"column-" + column.name}>
                                                        <div><SessionCell column={column} row={row} match={match} compacted={view === "COMPACT"}></SessionCell></div>
                                                    </td>
                                                ) : (
                                                    <></>
                                                )
                                            )}
                                        </tr>
                                    )}
                                    {state.total>state.data.length?
                                    <tr>
                                        <td colSpan={nbColumns} className="sensor-td">
                                            <VisibilitySensor
                                                onChange={(evt) => {
                                                    if (evt) {
                                                        console.log("sensor triggered, batch", batch);
                                                        loadData(batch);
                                                    }
                                                }}
                                            >
                                                <div className="sensor">{t("loading")}...</div>
                                            </VisibilitySensor>
                                        </td>
                                    </tr>:<></>}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="cards-list">
                                {state.data.map((row, index) => (
                                    <div className={"card" + (row.checked ? " checked" : "")}><div
                                        className="select-checkbox"
                                        onClick={() => toggleRowCheck(row)}
                                    >{row.checked ? <Check size="16"></Check> : ""}</div><SessionCard match={match} row={row}></SessionCard></div>
                                ))}
                                    {state.total>state.data.length?
                                            <VisibilitySensor
                                            onChange={(evt) => {
                                                if (evt) {
                                                    console.log("sensor triggered, batch", batch);
                                                    loadData(batch);
                                                }
                                            }}
                                        >
                                            <div className="sensor">{t("loading")} {state.total}...</div>
                                        </VisibilitySensor>:<></>}
                        </div>
                        )}
                    </IntlProvider>
                </PerfectScrollbar>
            </div>
        </div>
    );
}
export default PagingTable;
